import {SORT_FIELDS} from '../base.js'
import {SORT_BY_INSTALMENT_PRICE, SORT_BY_KM, SORT_BY_PRICE, SORT_BY_RELEVANCE, SORT_BY_YEAR} from './ads.js'

export const IS_PRICE_DROP_BUTTON_ENABLED = true
export const FAVORITES_EMPTY_CASE_ASSET_PATH = 'empty-cases/empty-case-favorites-coches.svg'

export const SORT_FAVORITES = {
  ...SORT_BY_RELEVANCE,
  ...SORT_BY_PRICE,
  ...SORT_BY_INSTALMENT_PRICE,
  ...SORT_BY_KM,
  ...SORT_BY_YEAR
}

export const SORTABLE_FAVORITE_FIELDS = {
  [SORT_FIELDS.PRICE]: item => item.price,
  [SORT_FIELDS.INSTALMENT]: item => item.financingInfo?.instalment,
  [SORT_FIELDS.YEAR]: item => item.year,
  [SORT_FIELDS.KM]: item => item.km
}
